import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import dalaService from "../services/dalaService";

const initialState = {
  dala: null,
  dalas: [],
  loading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  pageNumber: 0,
  pageSize: 10,
};

const dalaSlice = createModule({
  name: "dala",
  initialState,

  /* ============================================
     REDUCERS
  ============================================ */
  reducers: {

    list: (state) => { state.loading = true; },
    getById: (state) => { state.loading = true; },
    createDala: (state) => { state.loading = true; },
    updateDala: (state) => { state.loading = true; },
    deleteDala: (state) => { state.loading = true; },
    clearFormState: (state) => {
      state.dala = null;
      state.loading = false;
      state.error = null;
    },

    fetchedList: (state, payload) => {
      state.loading = false;
      state.dalas = payload.content || payload || [];
      state.totalElements = payload.totalElements || 0;
      state.totalPages = payload.totalPages || 0;
    },

    fetchedOne: (state, payload) => {
      state.loading = false;
      state.dala = payload;
    },

    finishFetching: (state) => {
      state.loading = false;
    },

    fetchError: (state, action) => {
      state.loading = false;
      state.error = action || "Une erreur est survenue";
    },
  },

  /* ============================================
     SAGAS
  ============================================ */
  sagas: (A) => ({

    /* ===== LIST ===== */
    *[A.list]({ payload }) {
      try {
        const { data } = yield call(dalaService.list, payload);
        yield put(A.fetchedList(data));
      } catch (e) {
        console.log(e);
        yield put(A.fetchError());
      }
    },

    /* ===== GET ONE ===== */
    *[A.getById]({ payload }) {
      try {
        const { data } = yield call(dalaService.getById, payload.id);
        yield put(A.fetchedOne(data));
        if (payload.onSuccess) yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.fetchError());
      }
    },

    /* ===== SAVE ===== */
    *[A.createDala]({ payload }) {
      try {
        const { data } = yield call(dalaService.save, payload.data);
        yield put(A.finishFetching());
        yield put(A.list());
        if (payload.onSuccess) yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.fetchError());
        if (payload.onError) yield call(payload.onError);
      }
    },

    /* ===== UPDATE ===== */
    *[A.updateDala]({ payload }) {
      try {
        const { data } = yield call(
          dalaService.update,
          payload.id,
          payload.data
        );
        yield put(A.finishFetching());
        yield put(A.getById({ id: payload.id }));
        if (payload.onSuccess) yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.fetchError());
      }
    },

    /* ===== DELETE ===== */
    *[A.deleteDala]({ payload }) {
      try {
        yield call(dalaService.delete, payload.id);
        yield put(A.list());
        if (payload.onSuccess) yield call(payload.onSuccess);
      } catch (e) {
        console.log(e);
        yield put(A.fetchError());
      }
    },

  }),
});

export default dalaSlice;
export const dalaActions = dalaSlice.actions;
